export default "__VITE_ASSET__CXIFWryS__"